<template>
    <div>
        <sammio-actions></sammio-actions>

        <div class="container">
            <div class="row">
                <section class="col-md-8 my-5 asset-display-page" id="sammio__element--main">

                  <div class="alert text-center my-5" v-if="!isLoaded" role="alert" aria-busy="true">
                    <p class=""><strong>{{$t('sammio.news.loading')}}</strong></p>
                  </div>
                  <div class="alert text-center my-5" v-else-if="isLoaded && !hasNews">
                    <p class=""><strong>{{$t('sammio.news.no_publications')}}</strong></p>
                  </div>
                  <div class="news" v-else>
                    <h1 class="my-3">{{ newsContent.title }}</h1>
                    <p class="news__meta">
                      <span class="news__meta--type">{{ newsContent.type }}</span>
                      <span class="news__meta--date ml-3">{{ this.formatDate }}</span>
                    </p>
                    <p class="lead">{{ newsContent.lead }}</p>
                    <div class="" v-html="newsContent.body"></div>
                  </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import * as http from "../store/http";
    import SammioActions from "./SammioActions";

    export default {
        name: "SammioNews",
        components: {
            SammioActions
        },
        props: {
            articleType: String
        },
        data() {
            return {
              newsContent: this.getNewsContent(),
              isLoaded: false,
              hasNews: false
            }
        },
        computed: {
          formatDate() {
            if (this.newsContent.displayDate !== undefined) {
              // Remove HH:MM from date
              return this.newsContent.displayDate.substr(0, this.newsContent.displayDate.lastIndexOf(" "));
            }
          },
        },
        methods: {
          getNewsContent() {
            http.get('/get-content', this.$store.state.portletId, {info: this.articleType})
                .then(response => {
                  this.isLoaded = true;
                 // Check if there are returned entries
                  if (response.data.body !== "") {
                    this.hasNews = true;
                    this.newsContent = response.data;
                  }

                })
                .catch(error => {
                  console.log(error);
                })
          }
        },
        watch: {
            $route(to, from) {
                if (this.$router.currentRoute.name === this.articleType) {
                    this.getNewsContent()
                }
            },
            locale(lang) {
                if (this.$router.currentRoute.name === this.articleType) {
                    this.getNewsContent()
                }
            }
        }
    }
</script>

<style>

</style>